import {
    Component,
    ElementRef,
    HostListener,
    Inject,
    Input,
    OnInit,
    inject,
} from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ApplicationService } from 'app/services/application.service';
import { NgbModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { CalendarDetailsComponent } from '../calendar-details/calendar-details.component';
import { CalendarEventsComponent } from '../calendar-events/calendar-events.component';
import { MatIconModule } from '@angular/material/icon';
import { HeaderComponent } from '../header/header.component';
import { PrimeNGConfig } from 'primeng/api';
import { formatTime } from 'app/shared/utils';
import { LoaderComponent } from '../loader/loader.component';

@Component({
    selector: 'app-calendar-view-mobile',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        CalendarModule,
        NgbModalModule,
        TranslateModule,
        CalendarEventsComponent,
        MatIconModule,
        HeaderComponent,
        LoaderComponent
    ],
    templateUrl: './calendar-view-mobile.component.html',
    styleUrls: ['./calendar-view-mobile.component.scss'],
})
export class CalendarViewMobileComponent implements OnInit {
    heading = 'LNDP_CALENDAR.PROGRAM_CALENDAR';
    eventCategories = [
        {
            color: `tw-bg-[#EF0002]`,
            label: 'LNDP_CALENDAR.ADVISORY_WORKSHOP',
        },
        {
            color: `tw-bg-[#FEC607]`,
            label: 'LNDP_CALENDAR.ACCESS_NEW_MARKETS',
        },
        {
            color: `tw-bg-[#009242]`,
            label: 'LNDP_CALENDAR.NETWORKING_SESSION',
        },
    ];
    subCategories = [
        {
            label: 'LNDP_CALENDAR.BUSINESS_PLAN',
        },
        {
            label: 'LNDP_CALENDAR.FINANCIAL_LITERACY',
        },
        {
            label: 'LNDP_CALENDAR.MARKETING_SALES',
        },
        {
            label: 'LNDP_CALENDAR.HALAL',
        },
        {
            label: 'COMMON.ESG',
        },
        {
            label: 'LNDP_CALENDAR.BUSINESS_EXPANSION',
        },
    ];
    languageSelected: any;
    tagsAcronym = [
        {
            tags: 'LNDP_CALENDAR.AW',
            class: '#EF0002',
        },
        {
            tags: 'LNDP_CALENDAR.ANM',
            class: '#FEC607',
        },
        {
            tags: 'LNDP_CALENDAR.NS',
            class: '#009242',
        },
    ];
    @Input() calendarRes;
    events = [];
    eventMonths = [];
    eventDays = [];
    initialEventDaysList = [];
    modalData: {
        action: string;
        event: [];
        isMobileView: boolean;
    };
    clickedOutside: boolean = false;
    isFilterOpen: boolean = false;
    initialProductsList = [];
    filteredProducts = [];
    checkboxStates: { [key: string]: boolean } = {};
    apiResponse: boolean = false;

    private modalService = inject(NgbModal);

    constructor(
        private applicationService: ApplicationService,
        private modal: NgbModal,
        private elRef: ElementRef,
        private config: PrimeNGConfig,
        private translateService: TranslateService,
        @Inject(DOCUMENT) private document: Document
    ) {}

    @HostListener('window:scroll', [])
    onWindowScroll() {
        const minScroll = 3000;
        const maxScroll =
            Number(localStorage.getItem('YPosition-app-calendar-view-mobile')) *
            4.5;
        const toTop = document.querySelector('.to-top-mobile');
        if (window.pageYOffset > minScroll && window.pageYOffset < maxScroll) {
            toTop.classList.add('active');
        } else {
            toTop.classList.remove('active');
        }
    }

    scrollToTop() {
        window.scrollTo(0, 1600);
    }

    ngOnInit() {
        this.languageSelected = localStorage.getItem('language');
        //get events by current month and year
        const date = new Date();
        let month = date.getMonth() + 1;
        let currentMonth = month;
        let currentYear = date.getFullYear();
        this.getCalendarEventsRes(currentMonth, currentYear);
    }

    getCalendarEventsRes(month, year) {
        this.applicationService.getCalendarDetails(month, year).subscribe({
            next: (res) => {
                this.apiResponse = true;
                this.calendarRes = res;
                //get events by current month and year
                this.getCalendarEvents();
                
                /* For Scroll Section after getting list of Calendar response*/
                this.findYPosition('app-footer');
                this.findYPosition('app-calendar-view');
                this.findYPosition('app-calendar-view-mobile');
            },
            error: (err) => {
                this.apiResponse = true;
            },
        });
    }

    findYPosition(elementName: any) {
        const note = document.getElementsByTagName(elementName)[0];
        const details = note.getBoundingClientRect();
        const initialYPosition = details.y.toString();
        const nameSet = 'YPosition-' + elementName;
        localStorage.setItem(nameSet, initialYPosition);
    }

    getCalendarEvents() {
        let calendarRes = this.calendarRes;

        //get event days and months to show dots on calendar
        let getDaysMonth = calendarRes.map((element) => {
            const eventDate: any = new Date(element.date);
            let day = eventDate.getDate();
            let month = new Date(eventDate).getMonth();
            return {
                day: day,
                month: month,
            };
        });
        this.eventDays = getDaysMonth.reduce((unique, o) => {
            if (!unique.some((obj) => obj.day === o.day)) {
                unique.push(o);
            }
            return unique;
        }, []);
        this.initialEventDaysList = this.eventDays;

        this.events = calendarRes
            .map((element) => {
                const inputDate: any = new Date(element.date).setHours(
                    0,
                    0,
                    0,
                    0
                );
                const currentDate: any = new Date().setHours(0, 0, 0, 0);
                const getCurrentTime = new Date().toLocaleTimeString();

                let isPastDate = false;

                if (inputDate < currentDate) {
                    element.class = '#D5D4D4';
                    isPastDate = true;
                } else if (inputDate == currentDate) {
                    if (element.startTime < getCurrentTime) {
                        element.class = '#D5D4D4';
                        isPastDate = true;
                    }
                }

                //Bind catgeories for colours instead of tags

                if (element.category === 'Advisory Workshops') {
                    element.seperatorClass = this.tagsAcronym[0].tags;
                    if (!isPastDate) {
                        element.class = this.tagsAcronym[0].class;
                    }
                } else if (element.category === 'Access New Markets') {
                    element.seperatorClass = this.tagsAcronym[1].tags;
                    if (!isPastDate) {
                        element.class = this.tagsAcronym[1].class;
                    }
                } else if (element.category === 'Networking Sessions') {
                    element.seperatorClass = this.tagsAcronym[2].tags;
                    if (!isPastDate) {
                        element.class = this.tagsAcronym[2].class;
                    }
                }

                let timeDiff = this.getTimeDiff(
                    element.endTime,
                    element.startTime
                );

                const isEnableEvent = element.enabled == 'yes';

                let isRegisterEventDisable = false;
                if (isPastDate) {
                    isRegisterEventDisable = true;
                } else if (
                    !isEnableEvent ||
                    element.isRegistered == 'Registered to Event'
                ) {
                    isRegisterEventDisable = true;
                }

                return {
                    id: element.id,
                    start: new Date(element.date),
                    date: this.formatDate(element.date),
                    title: element.title,
                    tags: element.tags,
                    meta: {
                        mode: element.eventType,
                        class: `tw-bg-[${element.class}]`,
                    },
                    category: element.category,
                    subcategory: element.subcategory,
                    venue: element.venue,
                    eventDescription: element.eventDescription,
                    link: element.link,
                    startTime: formatTime(element.startTime),
                    endTime: formatTime(element.endTime),
                    isRegistered: element.isRegistered,
                    tophat: element.tophat,
                    pastDate: isPastDate,
                    timeDiff: timeDiff,
                    isRegisterEventDisable,
                };
            })
            .sort(this.sortByDate);
        const initialArray = this.events;
        this.initialProductsList = this.nestedCopy(initialArray);
    }

    toggleFilter(e) {
        if (this.isFilterOpen == e) {
            return;
        }
        this.isFilterOpen = e;
    }

    changeMenuCondition(event: any) {
        this.clickedOutside = false;
    }

    closeMegaMenuCondition() {
        this.clickedOutside = !this.clickedOutside;
    }

    // after selecting from filter if anywhere elese clicked then filter should be closed
    @HostListener('document:click', ['$event'])
    handleClickOutside(event: Event) {
        const targetElement = event.target as HTMLElement;
        const filterElement =
            this.elRef.nativeElement.querySelector('.filter-container');
        if (!filterElement.contains(targetElement)) {
            this.isFilterOpen = false;
        }
    }

    addIfNotExists(value: any, array: any[]): void {
        // Check if the value is not already present in the array
        if (array.indexOf(value) === -1) {
            // If not present, add the value to the array
            array.push(value);
        }
    }

    removeProviders(prodCat) {
        let removeIndex = this.filteredProducts.findIndex(
            (item) => item === prodCat
        );
        if (removeIndex !== -1) {
            this.filteredProducts.splice(removeIndex, 1);
        }
    }

    onFilterProduct(event, prodCategory) {
        let prodCat = prodCategory;
        this.checkboxStates[prodCat] = event.target.checked;
        let selectedProdCat = prodCat;

        if (prodCat === 'Advisory Workshops') {
            this.checkboxStates['Business Plan'] = event.target.checked;
            this.checkboxStates['Financial Literacy'] = event.target.checked;
            this.checkboxStates['Marketing and Sales'] = event.target.checked;
            this.checkboxStates['Halal'] = event.target.checked;
            this.checkboxStates['ESG'] = event.target.checked;
            this.checkboxStates['Business Expansion'] = event.target.checked;
            if (event.target.checked) {
                this.addIfNotExists(
                    'Advisory Workshops',
                    this.filteredProducts
                );
                this.addIfNotExists('Business Plan', this.filteredProducts);
                this.addIfNotExists(
                    'Financial Literacy',
                    this.filteredProducts
                );
                this.addIfNotExists(
                    'Marketing and Sales',
                    this.filteredProducts
                );
                this.addIfNotExists('Halal', this.filteredProducts);
                this.addIfNotExists('ESG', this.filteredProducts);
                this.addIfNotExists(
                    'Business Expansion',
                    this.filteredProducts
                );
            } else {
                this.removeProviders('Advisory Workshops');
                this.removeProviders('Business Plan');
                this.removeProviders('Financial Literacy');
                this.removeProviders('Marketing and Sales');
                this.removeProviders('Halal');
                this.removeProviders('ESG');
                this.removeProviders('Business Expansion');
            }

            this.events = this.initialProductsList;
            // Apply all filters at once
            this.filteredProducts.forEach((filter) => {
                this.filterProductFn(selectedProdCat, filter);
            });
        } else if (prodCat === 'Access New Markets') {
            this.events = this.initialProductsList;

            if (event.target.checked) {
                this.addIfNotExists(
                    'Access New Markets',
                    this.filteredProducts
                );
            } else {
                this.removeProviders('Access New Markets');
            }
            // Apply all filters at once
            this.filteredProducts.forEach((filter) => {
                this.filterProductFn(selectedProdCat, filter);
            });
        } else if (prodCat === 'Networking Sessions') {
            this.events = this.initialProductsList;
            if (event.target.checked) {
                this.addIfNotExists(
                    'Networking Sessions',
                    this.filteredProducts
                );
            } else {
                this.removeProviders('Networking Sessions');
            }
            // Apply all filters at once
            this.filteredProducts.forEach((filter) => {
                this.filterProductFn(selectedProdCat, filter);
            });
        } else {
            let subCatArr = [
                {
                    label: 'Business Plan',
                },
                {
                    label: 'Financial Literacy',
                },
                {
                    label: 'Marketing and Sales',
                },
                {
                    label: 'Halal',
                },
                {
                    label: 'ESG',
                },
                {
                    label: 'Business Expansion',
                },
            ];
            if (event.target.checked) {
                subCatArr.forEach((ele) => {
                    if (ele.label === prodCat) {
                        ele['checked'] = event.target.checked;
                        this.addIfNotExists(prodCat, this.filteredProducts);
                    }
                });
                let subCategoriesCheck = subCatArr.every(
                    (ele) => ele['checked'] == true
                );
                if (subCategoriesCheck) {
                    this.checkboxStates['Advisory Workshops'] =
                        event.target.checked;
                    this.addIfNotExists(
                        'Advisory Workshops',
                        this.filteredProducts
                    );
                }
            } else {
                subCatArr.forEach((ele) => {
                    if (ele.label === prodCat) {
                        ele['checked'] = event.target.checked;
                        this.removeProviders(prodCat);
                    }
                });
                this.checkboxStates['Advisory Workshops'] = false;
                this.removeProviders('Advisory Workshops');

                let removeIndex = this.filteredProducts.findIndex(
                    (item) => item === prodCat
                );
                if (removeIndex !== -1) {
                    this.filteredProducts.splice(removeIndex, 1);
                }
            }
            this.events = this.initialProductsList;
            // Apply all filters at once
            this.filteredProducts.forEach((filter) => {
                this.filterProductFn('Advisory Workshops', filter);
            });
        }

        if (this.filteredProducts.length == 0) {
            //get event days and months to show dots on calendar
            this.eventDays = this.initialEventDaysList;
        }
    }

    filterProductFn(selectedProdCat, filter?) {
        if (
            selectedProdCat == 'Advisory Workshops' ||
            selectedProdCat == 'Access New Markets' ||
            selectedProdCat == 'Networking Sessions'
        ) {
            let filteredEvents = this.events.filter((item: any) => {
                if (
                    this.filteredProducts.includes(item?.category) ||
                    this.filteredProducts.includes(item?.subcategory)
                ) {
                    return item;
                }
            });
            this.events = filteredEvents;

            //get event days and months to show dots on calendar
            let getDaysMonth = this.events.map((element) => {
                const eventDate: any = new Date(element.date);
                let day = eventDate.getDate();
                let month = new Date(eventDate).getMonth();
                return {
                    day: day,
                    month: month,
                };
            });
            this.eventDays = getDaysMonth.reduce((unique, o) => {
                if (!unique.some((obj) => obj.day === o.day)) {
                    unique.push(o);
                }
                return unique;
            }, []);
        }
    }

    nestedCopy(array) {
        return Array.from(array);
    }

    sortByDate = (a, b) => {
        let date1: any = new Date(a.start);
        let date2: any = new Date(b.start);
        return date1 - date2;
    };

    onClickEvent(date, id) {
        let selectedDate = new Date(date);
        let openCalendarDetails = false;
        let eventData: any = this.events.filter((element) => {
            const currentDate: any = new Date(element.date).setHours(
                0,
                0,
                0,
                0
            );
            const userSelectedDate: any = selectedDate.setHours(0, 0, 0, 0);
            if (userSelectedDate === currentDate && id === element.id) {
                openCalendarDetails = true;
                return userSelectedDate === currentDate;
            }
        });
        if (openCalendarDetails) {
            this.modalData = {
                event: eventData[0],
                action: '',
                isMobileView: true,
            };
            const modalRef = this.modalService.open(CalendarDetailsComponent, {
                size: 'xs',
                backdrop: true,
                centered: true,
                windowClass: 'calendar-mobile-details',
            });
            modalRef.componentInstance.data = this.modalData;
        }
    }

    onSelectMonth(event) {
        localStorage.setItem('pickedMonth', JSON.stringify(event));
        let selectedMonth = event.month;
        let selectedYear = event.year;
        this.getCalendarEventsRes(selectedMonth, selectedYear);
    }

    getTimeDiff(t2, t1) {
        let getT2 = t2.split(':');
        let getT1 = t1.split(':');
        let t2Hrs = getT2[0];
        let t2Mins = getT2[1];
        let t1Hrs = getT1[0];
        let t1Mins = getT1[1];

        let hours;
        let mins;

        if (t1Hrs < t2Hrs) {
            hours = t2Hrs - t1Hrs;
        } else if (t1Hrs > t2Hrs) {
            hours = t1Hrs - t2Hrs;
        } else if (t1Hrs === t2Hrs) {
            hours = t2Hrs - t1Hrs;
        }

        if (t1Mins < t2Mins) {
            mins = t2Mins - t1Mins;
        } else if (t1Mins > t2Mins || t1Mins === t2Mins) {
            mins = t1Mins - t2Mins;
        }

        let hrsFormat;
        let hrsString;
        if (hours > 1) {
            hrsString = 'hrs ';
            hrsFormat = hours + hrsString;
        } else if (hours === 1) {
            hrsString = 'hr ';
            hrsFormat = hours + hrsString;
        } else if (hours === 0) {
            hrsString = '';
            hrsFormat = '';
        }

        let minsFormat;
        let minsString;
        if (mins > 9) {
            minsString = 'mins ';
            minsFormat = mins + minsString;
        } else if (mins > 0 && mins < 10) {
            minsString = 'min ';
            minsFormat = mins + minsString;
        } else if (mins === 0) {
            minsString = '';
            minsFormat = '';
        }
        return hrsFormat + minsFormat;
    }

    changeMonthLanguage(e: any) {
        this.languageSelected = e;
        let data = JSON.parse(localStorage.getItem('pickedMonth'));
        this.onSelectMonth(data);
    }

    formatDate(inputTime: string) {
        let dateObj = new Date(inputTime);
        let langDate = '';
        if (this.languageSelected == 'bm') {
            langDate = 'ms-MY';
        } else {
            langDate = 'en-US';
        }
        let month = dateObj.toLocaleString(langDate, { month: 'short' });
        let day = dateObj.getDate();
        let year = dateObj.getFullYear();
        let formattedDate = day + ' ' + month;
        return formattedDate;
    }

    onSubmit(link) {
        window.open(link, '_blank');
    }

    readLocalStorageValue(key: string) {
        let value = localStorage.getItem(key);
        this.translateService.use(value);
        this.translateService
            .get('primeng')
            .subscribe((res) => this.config.setTranslation(res));
    }
}
